import { EVENT_NAME, trackAnalyticsEvent } from "@leagueplatform/analytics";
import { StackItem, TextAction } from "@leagueplatform/genesis-core";
import { FooterLinkProps } from "@leagueplatform/solutions-foundation";

export const FOOTER_SCREEN_NAME = "footer";

export const FooterLink = ({
  url,
  text,
  onClick,
  linkProps,
}: FooterLinkProps) => {
  const trackAnalytics = (eventName: EVENT_NAME, targetDetail: string) => {
    trackAnalyticsEvent(eventName, {
      sub_detail: targetDetail,
      detail: "footer link clicked",
      screen_name: FOOTER_SCREEN_NAME,
      product_area: FOOTER_SCREEN_NAME,
    });
  };

  const handleClick = (event: React.MouseEvent, item: FooterLinkProps) => {
    trackAnalytics(
      item.url ? EVENT_NAME.RESOURCE_CLICKED : EVENT_NAME.BUTTON_CLICKED,
      item.text
    );
    if (item.onClick) {
      event.preventDefault();
      item.onClick();
    }
  };

  return (
    <StackItem as="li">
      <TextAction
        size="medium"
        onClick={(event: React.MouseEvent<HTMLAnchorElement>) =>
          handleClick(event, { url, text, onClick })
        }
        {...(url
          ? {
              as: "a",
              href: url,
              indicator: "externalLink",
              target: "_blank",
              rel: "noopener noreferrer",
            }
          : { as: "button" })}
        {...linkProps}
        css={{ color: "$onSurfaceTextReversed" }}
      >
        {text}
      </TextAction>
    </StackItem>
  );
};
